<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">智能开票</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <Tabs :datas="tabDatas" v-model="tab" @change="onTab" class-name="h-tabs-card"></Tabs>
            <span class="flex-spacer"></span>
            <Button size="s" @click="loadList">刷新</Button>
        </div>

        <!-- 主开票页 -->
        <div class="h-panel-body" v-if="tab==='main'">
            <div class="inv-layout">
                <div class="inv-main">
                    <!-- 购买方 -->
                    <div class="inv-block">
                        <div class="inv-block-title">购买方 <span class="inv-tip">AI识别</span>
                            <Button size="xs" @click="notOpen('图片识别')">图片识别</Button>
                            <Button size="xs" @click="notOpen('粘贴并识别')">粘贴并识别</Button>
                        </div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="类型">
                                <Radio v-model="form.buyerType" :datas="buyerTypeOptions" @change="onBuyerType"></Radio>
                            </FormItem>
                            <FormItem label="发票抬头"><input type="text" v-model="form.buyerTitle" placeholder="输入抬头"></FormItem>
                            <template v-if="form.buyerType===1">
                                <FormItem label="企业税号"><input type="text" v-model="form.buyerTaxNo" placeholder="请输入企业税号"></FormItem>
                            </template>
                            <template v-else>
                                <FormItem label="姓名"><input type="text" v-model="form.agentName" placeholder="请输入"></FormItem>
                                <FormItem label="国籍（地区）">
                                    <Select v-model="form.agentCountry" :datas="countryOptions" :deletable="false"></Select>
                                </FormItem>
                                <FormItem label="证件类型">
                                    <Select v-model="form.agentIdType" :datas="idTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                                </FormItem>
                                <FormItem label="证件号码"><input type="text" v-model="form.agentIdNo" placeholder="请输入"></FormItem>
                                <FormItem label="自然人纳税人识别号"><input type="text" v-model="form.agentTaxNo" placeholder="请输入"></FormItem>
                            </template>
                        </Form>
                    </div>

                    <!-- 销售方 -->
                    <div class="inv-block">
                        <div class="inv-block-title">销售方 <span class="inv-tip">授信总额度：¥0 可用总额度：¥0</span>
                            <Button size="xs" @click="notOpen('更新额度')">更新额度</Button>
                        </div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="名称"><input type="text" v-model="form.sellerName" placeholder="请输入"></FormItem>
                            <FormItem label="纳税人识别号"><input type="text" v-model="form.sellerTaxNo" placeholder="请输入"></FormItem>
                        </Form>
                    </div>

                    <!-- 开票项目明细 -->
                    <div class="inv-block">
                        <div class="inv-block-title">开票项目明细
                            <Button size="xs" color="primary" @click="addItem">添加行</Button>
                            <Button size="xs" @click="notOpen('明细导入')">明细导入</Button>
                        </div>
                        <table class="sub-grid">
                            <thead>
                            <tr>
                                <th>商品名称</th><th>规格型号</th><th>单位</th><th>数量</th>
                                <th>单价(含税)</th><th>税率</th><th>开票金额(含税)</th><th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(it,i) in form.items" :key="i">
                                <td><input type="text" v-model="it.goodsName"></td>
                                <td><input type="text" v-model="it.spec"></td>
                                <td><input type="text" v-model="it.unit"></td>
                                <td><NumberInput v-model="it.qty" :precision="2" :min="0" style="width:70px" @change="calcItem(it)"></NumberInput></td>
                                <td><NumberInput v-model="it.priceInclTax" :precision="4" :min="0" style="width:90px" @change="calcItem(it)"></NumberInput></td>
                                <td><NumberInput v-model="it.taxRate" :precision="4" :min="0" style="width:70px" @change="calcItem(it)"></NumberInput></td>
                                <td align="right">{{it.amountInclTax|numFormat}}</td>
                                <td><span class="del" @click="form.items.splice(i,1)">删</span></td>
                            </tr>
                            <tr v-if="!form.items.length"><td colspan="8" class="text-center padding">请添加开票项目</td></tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 开票信息 -->
                    <div class="inv-block">
                        <div class="inv-block-title">开票信息</div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="价税合计"><b>{{form.amountInclTax|numFormat}}</b></FormItem>
                            <FormItem label="税额"><b>{{form.taxAmount|numFormat}}</b></FormItem>
                            <FormItem label="不含税金额"><b>{{form.amountExclTax|numFormat}}</b></FormItem>
                        </Form>
                    </div>

                    <!-- 备注信息 -->
                    <div class="inv-block">
                        <div class="inv-block-title">备注信息</div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="备注"><textarea rows="2" v-model="form.remark" placeholder="请输入"></textarea></FormItem>
                            <FormItem label="收款人"><input type="text" v-model="form.payee" placeholder="请输入"></FormItem>
                            <FormItem label="复核人"><input type="text" v-model="form.checker" placeholder="请输入"></FormItem>
                        </Form>
                    </div>

                    <!-- 发票接收 -->
                    <div class="inv-block">
                        <div class="inv-block-title">发票接收</div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="手机号"><NumberInput v-model="form.phone" placeholder="请输入手机号码接收发票"></NumberInput></FormItem>
                            <FormItem label="邮箱地址"><input type="text" v-model="form.email" placeholder="请输入邮箱地址接收发票"></FormItem>
                        </Form>
                    </div>

                    <!-- 支付信息 -->
                    <div class="inv-block">
                        <div class="inv-block-title">支付信息
                            <Button size="xs" @click="notOpen('新增')">新增</Button>
                        </div>
                        <Form :labelWidth="100" :model="form">
                            <FormItem label="支付渠道">
                                <Select v-model="form.payChannel" :datas="payChannelOptions" :deletable="false"></Select>
                            </FormItem>
                            <FormItem label="交易单号"><input type="text" v-model="form.payTradeNo" placeholder="请输入"></FormItem>
                        </Form>
                    </div>

                    <div class="text-center margin-top">
                        <Button color="green" @click="saveDraft" :loading="loading">保存草稿</Button>
                        <Button @click="notOpen('预览发票')">预览发票</Button>
                        <Button color="primary" @click="issue" :loading="loading">开票</Button>
                    </div>
                </div>

                <!-- 发票订单列表 -->
                <div class="inv-orders">
                    <div class="inv-block-title">发票订单</div>
                    <table class="grid">
                        <thead>
                        <tr><th>订单号</th><th>购买方</th><th>价税合计</th><th>状态</th><th>操作</th></tr>
                        </thead>
                        <tbody>
                        <tr v-for="o in orders" :key="o.id">
                            <td>{{o.orderNo}}</td>
                            <td>{{o.buyerTitle}}</td>
                            <td align="right">{{o.amountInclTax|numFormat}}</td>
                            <td>{{orderStatus(o.status)}}</td>
                            <td class="actions">
                                <span @click="editOrder(o)">编辑</span>
                                <span @click="removeOrder(o)">删除</span>
                            </td>
                        </tr>
                        <tr v-if="!orders.length"><td colspan="5" class="text-center padding">暂无订单</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- 开票项目 -->
        <div class="h-panel-body" v-else-if="tab==='project'">
            <table class="grid">
                <thead><tr><th>编码</th><th>名称</th><th>税率</th><th>规格</th><th>单位</th><th>操作</th></tr></thead>
                <tbody>
                <tr v-for="(c,i) in configItem" :key="c.id||('n'+i)">
                    <td><input type="text" v-model="c.code"></td>
                    <td><input type="text" v-model="c.name"></td>
                    <td><NumberInput v-model="c.taxRate" :precision="4" :min="0" style="width:90px"></NumberInput></td>
                    <td><input type="text" v-model="c.spec"></td>
                    <td><input type="text" v-model="c.unit"></td>
                    <td class="actions">
                        <span @click="saveConfig(c,'item')">保存</span>
                        <span class="del" @click="c.id?deleteConfig(c):configItem.splice(i,1)">删</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <Button size="s" color="primary" class="margin-top" @click="configItem.push({code:'',name:'',taxRate:0,spec:'',unit:'',configType:'item'})">新增开票项目</Button>
        </div>

        <!-- 税务信息 -->
        <div class="h-panel-body" v-else-if="tab==='tax'">
            <table class="grid">
                <thead><tr><th>编码</th><th>名称</th><th>操作</th></tr></thead>
                <tbody>
                <tr v-for="(c,i) in configTax" :key="c.id||('n'+i)">
                    <td><input type="text" v-model="c.code"></td>
                    <td><input type="text" v-model="c.name"></td>
                    <td class="actions">
                        <span @click="saveConfig(c,'tax')">保存</span>
                        <span class="del" @click="c.id?deleteConfig(c):configTax.splice(i,1)">删</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <Button size="s" color="primary" class="margin-top" @click="configTax.push({code:'',name:'',configType:'tax'})">新增税务信息</Button>
        </div>

        <!-- 开票设置 -->
        <div class="h-panel-body" v-else-if="tab==='setting'">
            <table class="grid">
                <thead><tr><th>编码</th><th>名称</th><th>配置值</th><th>操作</th></tr></thead>
                <tbody>
                <tr v-for="(c,i) in configSetting" :key="c.id||('n'+i)">
                    <td><input type="text" v-model="c.code"></td>
                    <td><input type="text" v-model="c.name"></td>
                    <td><input type="text" v-model="c.value"></td>
                    <td class="actions">
                        <span @click="saveConfig(c,'setting')">保存</span>
                        <span class="del" @click="c.id?deleteConfig(c):configSetting.splice(i,1)">删</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <Button size="s" color="primary" class="margin-top" @click="configSetting.push({code:'',name:'',value:'',configType:'setting'})">新增开票设置</Button>
        </div>

        <!-- 批量开票 -->
        <div class="h-panel-body" v-else>
            <p>批量开票：上传 Excel 模板后批量开具发票（功能暂未开放）。</p>
            <Button size="s" @click="notOpen('批量开票上传')">上传文件</Button>
        </div>
    </app-content>
</template>

<script>
const emptyForm = () => ({
    id: null, buyerType: 1, buyerTitle: '', buyerTaxNo: '', sellerName: '', sellerTaxNo: '',
    invoiceType: '数电发票（普通发票）', remark: '', payee: '', checker: '', phone: '', email: '',
    payChannel: '支付宝', payTradeNo: '', agentName: '', agentCountry: '中国', agentIdType: '居民身份证',
    agentIdNo: '', agentTaxNo: '', amountExclTax: 0, taxAmount: 0, amountInclTax: 0, items: []
});

export default {
    name: 'IntelligentInvoicing',
    data() {
        return {
            tab: 'main',
            tabDatas: { main: '智能开票', project: '开票项目', tax: '税务信息', setting: '开票设置', batch: '批量开票' },
            orders: [],
            form: emptyForm(),
            loading: false,
            buyerTypeOptions: [{ key: 1, title: '企业' }, { key: 2, title: '个人/其他' }],
            idTypeOptions: [
                { key: '居民身份证', title: '居民身份证' }, { key: '护照', title: '护照' }, { key: '其他', title: '其他' }
            ],
            countryOptions: ['中国', '中国香港', '中国澳门', '中国台湾', '其他'],
            payChannelOptions: ['支付宝', '微信支付', '银行卡', '现金'],
            configItem: [], configTax: [], configSetting: []
        };
    },
    methods: {
        fmtRate(r) { if (r == null) return '-'; return (Number(r) * 100).toFixed(2) + '%'; },
        orderStatus(v) { return ({ 0: '草稿', 1: '已开票', 2: '失败' })[v] || '-'; },
        onTab() {
            if (this.tab === 'project') this.loadConfig('item');
            else if (this.tab === 'tax') this.loadConfig('tax');
            else if (this.tab === 'setting') this.loadConfig('setting');
        },
        onBuyerType() { /* 企业/个人切换仅影响表单展示 */ },
        addItem() { this.form.items.push({ goodsName: '', spec: '', unit: '', qty: 0, priceInclTax: 0, taxRate: 0, amountInclTax: 0 }); },
        calcItem(it) {
            const price = Number(it.priceInclTax || 0);
            const qty = Number(it.qty || 0);
            const rate = Number(it.taxRate || 0);
            const incl = (price * qty).toFixed(2);
            it.amountInclTax = incl;
            this.recalcTotal();
        },
        recalcTotal() {
            let incl = 0, tax = 0;
            this.form.items.forEach(it => {
                const a = Number(it.amountInclTax || 0);
                const r = Number(it.taxRate || 0);
                incl += a;
                tax += (a - a / (1 + r)).toFixed(2) * 1;
            });
            this.form.amountInclTax = incl.toFixed(2);
            this.form.taxAmount = tax.toFixed(2);
            this.form.amountExclTax = (incl - tax).toFixed(2);
        },
        loadList() {
            this.$api.invoice.smart.list({}).then(({ data }) => { this.orders = data || []; });
        },
        loadConfig(type) {
            this.$api.invoice.smart.configs(type).then(({ data }) => {
                if (type === 'item') this.configItem = data || [];
                else if (type === 'tax') this.configTax = data || [];
                else this.configSetting = data || [];
            });
        },
        saveDraft() {
            const p = Object.assign({}, this.form);
            p.items = this.form.items.filter(i => i.goodsName);
            this.loading = true;
            this.$api.invoice.smart[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false;
                this.$Message.success('已保存草稿');
                this.loadList();
            }).catch(() => { this.loading = false; });
        },
        issue() {
            const p = Object.assign({}, this.form);
            p.items = this.form.items.filter(i => i.goodsName);
            this.loading = true;
            const done = (id) => {
                this.$api.invoice.smart.issue(id).then(({ msg }) => {
                    this.loading = false;
                    this.$Message.success(msg || '开票成功');
                    this.loadList();
                }).catch(() => { this.loading = false; });
            };
            if (this.form.id) { done(this.form.id); }
            else {
                this.$api.invoice.smart.save(p).then(({ data }) => {
                    done(data || (data && data.id));
                }).catch(() => { this.loading = false; });
            }
        },
        editOrder(o) {
            this.$api.invoice.smart.load(o.id).then(({ data }) => {
                this.form = Object.assign(emptyForm(), data);
                this.form.buyerType = data.buyerType || 1;
                this.form.items = data.items || [];
                this.tab = 'main';
                window.scrollTo(0, 0);
            });
        },
        removeOrder(o) {
            this.$Confirm('确认删除该订单?').then(() => {
                this.$api.invoice.smart.delete(o.id).then(() => this.loadList());
            });
        },
        saveConfig(c, type) {
            c.configType = type;
            this.$api.invoice.smart.saveConfig(c).then(() => {
                this.$Message.success('已保存');
                this.loadConfig(type);
            });
        },
        deleteConfig(c) {
            this.$Confirm('确认删除该配置?').then(() => {
                this.$api.invoice.smart.deleteConfig(c.id).then(() => this.loadConfig(c.configType));
            });
        },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); }
    },
    mounted() {
        this.loadList();
        this.$api.invoice.smart.options();
    }
};
</script>

<style scoped lang="less">
.filter-bar {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .flex-spacer { flex: 1; }
}

.inv-layout { display: flex; gap: 16px; align-items: flex-start; }
.inv-main { flex: 1; min-width: 0; }
.inv-orders { width: 360px; flex: none; }

.inv-block {
    border: 1px solid #e8e8e8; border-radius: 4px; padding: 10px 12px; margin-bottom: 12px;
    .inv-block-title {
        font-weight: bold; margin-bottom: 8px; display: flex; align-items: center; gap: 8px;
        .inv-tip { font-weight: normal; font-size: 12px; color: #999; }
    }
}

.sub-grid {
    width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 8px;
    th, td { border: 1px solid #e2e2e2; padding: 2px 4px; height: 30px; }
    th { background-color: #f5f5f5; text-align: center; }
    input[type=text] { width: 110px; height: 26px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 4px; }
}

.grid {
    width: 100%; border-collapse: collapse;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
}

.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.del { cursor: pointer; color: #f44336; }
</style>
